export default __webpack_public_path__ + "static/media/8.8e647315.png";